// approvals/slice.js

import { activeDelApprovalsAwaitingInitialState } from "./awaitingApproval/activeDelsApprovalsAwaitingApprovalState";
import { activeDelApprovedInitialState } from "./approved/activeDelsApprovalsApprovedState";
import { makeActiveDelApprovalsAwaitingActions } from "./awaitingApproval/activeDelsApprovalsAwaitingApprovalActions";
import { makeActiveDelApprovedActions } from "./approved/activeDelsApprovalsApprovedActions";

export const createActiveDelApprovalsSlice = (set, get) => ({
  // Awaiting approvals tab state/actions
  activeDelApprovalsAwaiting: activeDelApprovalsAwaitingInitialState,
  activeDelApprovalsAwaitingActions: Object.freeze(
    makeActiveDelApprovalsAwaitingActions(set, get)
  ),

  // Approved tab state/actions
  activeDelApproved: activeDelApprovedInitialState,
  activeDelApprovedActions: Object.freeze(
    makeActiveDelApprovedActions(set, get)
  ),
});
